import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

const schoolManagementRoutes: RouteRecordRaw = {
  path: "/schoolManagement",
  component: Layout,
  redirect: "/schoolManagement/schoolList",
  name: "SchoolManagement",
  meta: {
    title: "学校管理",
    icon: "homepage",
    permissionKey: "schoolManagement",
  },
  children: [
    {
      path: "schoolList",
      name: "SchoolList",
      component: () =>
        import("@/views/Workbench/school-management/school-list/index.vue"),
      meta: {
        title: "学校列表",
        icon: "homepage",
        permissionKey: "schoolManagement:schoolList",
      },
    },
    {
      path: "schoolDetail",
      name: "SchoolDetail",
      component: () =>
        import("@/views/Workbench/school-management/school-detail.vue"),
      meta: {
        title: "学校详情",
        icon: "homepage",
        hidden: true,
        permissionKey: "schoolManagement:schoolList",
      },
    },
    {
      path: "schoolContractList",
      name: "SchoolContractList",
      component: () =>
        import("@/views/Workbench/school-management/school-contract-list/index.vue"),
      meta: {
        title: "合同列表",
        icon: "homepage",
        permissionKey: "schoolManagement:schoolContractList",
      },
    },
    {
      path: "schoolContractDetail",
      name: "SchoolContractDetail",
      component: () =>
        import("@/views/Workbench/school-management/school-contract-detail.vue"),
      meta: {
        title: "合同详情",
        icon: "homepage",
        hidden: true,
        permissionKey: "schoolManagement:schoolContractList",
      },
    },
    {
      path: "examRoomList",
      name: "ExamRoomList",
      component: () =>
        import("@/views/Workbench/school-management/exam-room-list/index.vue"),
      meta: {
        title: "考场列表",
        icon: "homepage",
        permissionKey: "schoolManagement:examRoomList",
      },
    },
    {
      path: "classRoomList",
      name: "ClassRoomList",
      component: () =>
        import("@/views/Workbench/school-management/class-room-list/index.vue"),
      meta: {
        title: "教室列表",
        icon: "homepage",
        permissionKey: "schoolManagement:classRoomList",
      },
    },
    {
      path: "classList",
      name: "ClassList",
      component: () =>
        import("@/views/Workbench/class-management/class-list/index.vue"),
      meta: {
        title: "班级管理",
        icon: "homepage",
        permissionKey: "schoolManagement:classList",
      },
    },
    {
      path: "studentList",
      name: "ClassStudentList",
      component: () =>
        import("@/views/Workbench/class-management/student-list/index.vue"),
      meta: {
        title: "学生管理",
        icon: "homepage",
        permissionKey: "schoolManagement:studentList",
      },
    },
    {
      path: "contractTemplate",
      name: "SchoolManagementContractTemplate",
      component: () =>
        import("@/views/Workbench/school-management/contract-template-list/index.vue"),
      meta: {
        title: "合同模板",
        icon: "homepage",
        permissionKey: "system:contractTemplate",
      },
    },
  ],
};

export default schoolManagementRoutes;
